<ng-container *ngIf="icon">
  <ng-container *ngIf="icon && size">
    <img src="./assets/job-board/icons/{{icon}}.svg" alt="Icon"  [ngStyle]="{ 'width': size + 'rem'}"/>
  </ng-container>

  <ng-container *ngIf="icon && !size">
    <img src="./assets/job-board/icons/{{icon}}.svg" alt="Icon" />
  </ng-container>
</ng-container>
